import type { MarketLocale } from './market';
import { Env } from '@/consts/Env';
import { MARKET_LOCALES } from './market';

/**
 * Canada is a deployment-level capability. Only an explicit `true` enables
 * the public route so missing or malformed build configuration fails closed.
 */
export const isCanadaStorefrontEnabled = () => (
  Env.NEXT_PUBLIC_CANADA_STOREFRONT_ENABLED === 'true'
);

export const isStorefrontLocaleEnabled = (locale: MarketLocale) => (
  locale !== MARKET_LOCALES.CA || isCanadaStorefrontEnabled()
);
